import {capitalize, upperCaseName} from "../../helper/tools";
import Header from "../../components/common/Header";
import Icon from "../../components/common/Icon";
import {useEffect, useState} from "react";
import {getAgencyCondolenceList, rejectCondolence} from "../../api/pro/condolenceReq";
import {Link, useNavigate} from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import jwtDecode from "jwt-decode";
import {updateModeratedStatus, updatePublishedStatus, updatePrintedStatus} from "../../api/pro/condolenceReq";
import Missing from "../Missing";
import condolenceSource from "../../img/v2_i_condoleances.png";


export default function AgencyCondolenceModeration() {
    const sources = condolenceSource;
    const { auth } = useAuth();
    const token = auth.token;
    const decodedToken = jwtDecode(token);
    const id = decodedToken.agency;
    const [ condolenceList, setCondolenceList ] = useState();
    const [ expandedIds, setExpandedIds ] = useState([]);
    const navigate = useNavigate();

    // Déplie/replie une ligne (uniquement utile en mobile, cf. _dashboard.scss : le tableau
    // devient une liste de cartes dont seul le résumé est visible par défaut).
    const toggleExpand = (id) => {
        setExpandedIds(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
    };

    const apiCondolenceList = async () => {
        const response = await getAgencyCondolenceList(token, id)
        setCondolenceList(response)
    };

    const handleModerateStatus = async (e) => {
        let body = {
            "condolenceId": parseInt(e.currentTarget.getAttribute("id"))
        }
        await updateModeratedStatus(token, body)
        apiCondolenceList()
    };

    const handleWebPublishedStatus = (e) => {
        let publishedIcon = document.getElementById(`2-${e.currentTarget.getAttribute("id")}`);
        if (e.target.checked == true) {
            publishedIcon.classList.toggle("false");
            publishedIcon.classList.toggle("true");
            let body = {
                "publishedStatus": false,
                "condolenceId": parseInt(e.currentTarget.getAttribute("id")),
            }
            updatePublishedStatus(token, body)
        }
        if (e.target.checked === false) {
            publishedIcon.classList.toggle("false");
            publishedIcon.classList.toggle("true");
            let body = {
                "publishedStatus": true,
                "condolenceId": parseInt(e.currentTarget.getAttribute("id")),
            }
            updatePublishedStatus(token, body)
        }
        apiCondolenceList()
    };

    const handlePrintedStatus = (e) => {
        let printedIcon = document.getElementById(`3-${e.currentTarget.getAttribute("id")}`);
        if (e.target.checked == true) {
            printedIcon.classList.toggle("false");
            printedIcon.classList.toggle("true");
            let body = {
                "printedStatus": false,
                "condolenceId": parseInt(e.currentTarget.getAttribute("id")),
            }
            updatePrintedStatus(token, body)
        }
        if (e.target.checked === false) {
            printedIcon.classList.toggle("false");
            printedIcon.classList.toggle("true");
            let body = {
                "printedStatus": true,
                "condolenceId": parseInt(e.currentTarget.getAttribute("id")),
            }
            updatePrintedStatus(token, body)
        }
        apiCondolenceList()
    };

    // Variantes utilisées par les icônes de la carte mobile (pas de switch/checkbox, juste un
    // clic sur l'icône) : on connaît déjà le statut courant via `condolence`, pas besoin de lire
    // un `e.target.checked`.
    const toggleWebPublished = async (condolence) => {
        await updatePublishedStatus(token, {
            publishedStatus: !condolence?.public,
            condolenceId: condolence?.id,
        })
        apiCondolenceList()
    };

    const togglePrinted = async (condolence) => {
        await updatePrintedStatus(token, {
            printedStatus: !condolence?.print,
            condolenceId: condolence?.id,
        })
        apiCondolenceList()
    };

    const handleRejectCondolence = async (e) => {
        let body = {
            "condolenceId": parseInt(e.currentTarget.getAttribute("id"))
        }
        if(window.confirm("Voulez-vous vraiment refuser cette condoléance ?")) {
            await rejectCondolence(token, body)
            apiCondolenceList()
        }
    }

    useEffect(() => {
        apiCondolenceList()
    }, [ id ]);

    return (
        <main>
            { (condolenceList?.error) &&
                <Missing />
            }
            { (!condolenceList?.error) &&
            <>
            <Header
                location="Espace de modération des condoléances"
                parent="Tableau de bord"
                slug="/"
            />
            <div className="content-container">
                <Icon source={ sources } color="blue" span="Espace de modération des condoléances"/>
                <div className="dashboard">
                    <div className="flex">
                        {/* Desktop : tableau classique (masqué en mobile, cf. _dashboard.scss). */}
                        <table className="condolence-moderation desktop-only">
                            <thead>
                            <tr>
                                <th>Expéditeur</th>
                                <th>Message</th>
                                <th>Internet</th>
                                <th>Imprimer</th>
                                <th>Voir</th>
                                <th>Autoriser</th>
                                <th>Refuser</th>
                            </tr>
                            </thead>
                            <tbody>
                                { condolenceList?.filter(condolence => condolence?.new).map(condolence => (
                                    <tr key={condolence?.id}>
                                        <td>
                                            <h3>Message de {capitalize(condolence?.firstName)} {upperCaseName(condolence?.lastName)}</h3>
                                            <h2>Pour: <span className="deceased-name">{condolence?.deceasedFirstname} {condolence?.deceasedLastname}</span></h2>
                                            <span>Ce message doit encore être modéré.</span>
                                            <span className={`public-wish ${condolence?.public ? "wants-public" : "wants-private"}`}>
                                                {condolence?.public ? "A souhaité que son message soit publié sur Internet." : "N'a pas souhaité que son message soit publié sur Internet."}
                                            </span>
                                        </td>
                                        <td>
                                            <textarea value={condolence?.message}/>
                                        </td>
                                        <td>
                                            <label className="switch condolence">
                                                <i id={`2-${condolence?.id}`} className={condolence?.public ? `fa fa-globe true` : `fa fa-globe false`}/>
                                                <input defaultChecked={condolence?.public}
                                                    id={condolence?.id}
                                                    type="checkbox"
                                                    onChange={handleWebPublishedStatus}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </td>
                                        <td>
                                            <label className="switch condolence">
                                                <i id={`3-${condolence?.id}`} className={condolence?.print ? `fa fa-print true` : `fa fa-print false` }/>
                                                <input defaultChecked={condolence?.print}
                                                    id={condolence?.id}
                                                    type="checkbox"
                                                    onChange={handlePrintedStatus}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </td>
                                        <td className="condolence">
                                            <Link to={`/defunt/${condolence?.deceased}/condoleances/moderer`} target="_blank">
                                                <i className="fa fa-eye"/>
                                            </Link>
                                        </td>
                                        <td className="condolence">
                                            { condolence?.new &&
                                                <i onClick={handleModerateStatus} id={condolence?.id} className={condolence?.moderated ? `fa fa-check true` : `fa fa-check`}/>
                                            }
                                        </td>
                                        <td className="condolence">
                                            { condolence?.new &&
                                                <i onClick={handleRejectCondolence} id={condolence?.id} className="fa fa-close false"/>
                                            }
                                        </td>
                                    </tr>
                                ))}
                                { condolenceList?.filter(condolence => condolence?.new).length < 1 &&
                                    <tr>
                                        <td colSpan="7">Aucune condoléance à modérer.</td>
                                    </tr>
                                }
                            </tbody>
                        </table>

                        {/* Mobile : cartes dépliables (masquées en desktop, cf. _dashboard.scss). Simple
                            rendu conditionnel en JS (pas de display:none/block sur des <td>, qui se
                            heurtait à des bizarreries de rendu des tableaux selon les navigateurs). */}
                        <div className="condolence-cards mobile-only">
                            { condolenceList?.filter(condolence => condolence?.new).map(condolence => {
                                const isExpanded = expandedIds.includes(condolence?.id);
                                return (
                                    <div key={condolence?.id} className={`condolence-card ${isExpanded ? "expanded" : ""}`}>
                                        <div className="condolence-card-summary" onClick={() => toggleExpand(condolence?.id)}>
                                            <h3>Message de {capitalize(condolence?.firstName)} {upperCaseName(condolence?.lastName)}</h3>
                                            <h2>Pour: <span className="deceased-name">{condolence?.deceasedFirstname} {condolence?.deceasedLastname}</span></h2>
                                            <span>Ce message doit encore être modéré.</span>
                                            <span className={`public-wish ${condolence?.public ? "wants-public" : "wants-private"}`}>
                                                {condolence?.public ? "A souhaité que son message soit publié sur Internet." : "N'a pas souhaité que son message soit publié sur Internet."}
                                            </span>
                                            <i className={`fa expand-icon ${isExpanded ? "fa-chevron-up" : "fa-chevron-down"}`}/>
                                        </div>
                                        { isExpanded &&
                                            <div className="condolence-card-details">
                                                <div className="condolence-card-field">
                                                    <label>Message</label>
                                                    <textarea
                                                        value={condolence?.message}
                                                        readOnly
                                                        ref={(el) => {
                                                            if (el) {
                                                                el.style.height = "auto";
                                                                el.style.height = `${el.scrollHeight}px`;
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className="condolence-card-actions">
                                                    <div className="condolence-card-action-group">
                                                        <i onClick={() => toggleWebPublished(condolence)} className={condolence?.public ? `fa fa-globe true` : `fa fa-globe false`}/>
                                                        <i onClick={() => togglePrinted(condolence)} className={condolence?.print ? `fa fa-print true` : `fa fa-print false`}/>
                                                    </div>
                                                    <div className="condolence-card-action-group">
                                                        <Link to={`/defunt/${condolence?.deceased}/condoleances/moderer`} target="_blank">
                                                            <i className="fa fa-eye"/>
                                                        </Link>
                                                        { condolence?.new &&
                                                            <i onClick={handleModerateStatus} id={condolence?.id} className={condolence?.moderated ? `fa fa-check true` : `fa fa-check`}/>
                                                        }
                                                        { condolence?.new &&
                                                            <i onClick={handleRejectCondolence} id={condolence?.id} className="fa fa-close false"/>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                );
                            })}
                            { condolenceList?.filter(condolence => condolence?.new).length < 1 &&
                                <p>Aucune condoléance à modérer.</p>
                            }
                        </div>
                    </div>
                </div>
            </div>
            </>
            }
        </main>
    )
}